import React, { useContext } from 'react';
import { PriceContext } from '../../contexts/PriceContext';

const RealizationTime = () => {
  const { price } = useContext(PriceContext);

  return <p className="realization-info">Termin realizacji: {price.delivery} dni roboczych</p>;
};

export default RealizationTime;
